"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIAMETER_PLUTO = exports.DIAMETER_NEPTUNE = exports.DIAMETER_URANUS = exports.DIAMETER_SATURN = exports.DIAMETER_JUPITER = exports.DIAMETER_MARS = exports.DIAMETER_VENUS = exports.DIAMETER_MERCURY = void 0;
exports.DIAMETER_MERCURY = 4879.4;
exports.DIAMETER_VENUS = 12103.6;
exports.DIAMETER_MARS = 6792.4;
exports.DIAMETER_JUPITER = 142984;
exports.DIAMETER_SATURN = 120536;
exports.DIAMETER_URANUS = 51118;
exports.DIAMETER_NEPTUNE = 49528;
exports.DIAMETER_PLUTO = 2390;
